import { render, staticRenderFns } from "./TalentRatingsTabs.vue?vue&type=template&id=1ff88bd4"
import script from "./TalentRatingsTabs.vue?vue&type=script&lang=js"
export * from "./TalentRatingsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports